import { useBusinessCardStore, useGlobalStore } from '@shared/store';
import { useDefaultLink } from '@shared/hooks';
import { MANAGER_CARD_TYPE } from '@shared/config';

export const useAvatar = () => {
  const { isManagerView } = useGlobalStore();
  const { toPath } = useDefaultLink();
  const clickAvatar = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isManagerView) return;
    toPath('push', {
      path: 'app://caizhi_webapp/cardEditor',
      query: { type: MANAGER_CARD_TYPE.PageCard },
    });
  };

  return {
    clickAvatar,
  };
};
